import { FormSelectOption } from "@thecb/components";

export const EMPTY_OPTION = {
  text: "",
  value: "",
};

export const getDefaultFormSelectOption = (key: string) => ({
  text: `All ${key}`,
  value: "",
});

export const getSelectOptionsWithPlaceholder = (
  optionsWithoutPlaceholder: FormSelectOption[],
  value: string,
  nullable: boolean = false
): FormSelectOption[] => {
  // Need an empty dropdown option when there is no value (empty string), or the backend allows null for an optional field
  if (!value || nullable) {
    return [EMPTY_OPTION, ...optionsWithoutPlaceholder];
  } else {
    return optionsWithoutPlaceholder;
  }
};
